const env = process.env.REACT_APP_APP_ENV || 'development';

const configs = {
  development: {
    stripe_pk:
      'pk_test_51HUdjlKHVsvXDF4EfkN9LVGEwGcIAY6SiOHa5BXw8h1WGNsUEDTMexvaANt24olm60i2rDtbOQ4nO4yyCtvcPp3v00lkAud379',
  },
  staging: {
    stripe_pk:
      'pk_test_51HUdjlKHVsvXDF4EfkN9LVGEwGcIAY6SiOHa5BXw8h1WGNsUEDTMexvaANt24olm60i2rDtbOQ4nO4yyCtvcPp3v00lkAud379',
  },
  production: {
    stripe_pk:
      'pk_live_51HUdjlKHVsvXDF4EnWx6PvTmXmf78y6QLFsFm4T7bexptLDyWhGX3ecTsGm3wHKLPFAyM8ZpSqVZiLew8AjiY0f900RFtfLfbx',
  },
}[env];

export default configs;
